import { render, staticRenderFns } from "./TopTen.vue?vue&type=template&id=61db4f85&scoped=true"
import script from "./TopTen.vue?vue&type=script&lang=js"
export * from "./TopTen.vue?vue&type=script&lang=js"
import style0 from "./TopTen.vue?vue&type=style&index=0&id=61db4f85&prod&lang=less"
import style1 from "./TopTen.vue?vue&type=style&index=1&id=61db4f85&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61db4f85",
  null
  
)

export default component.exports